'use client';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserSearchBarProps } from './user-search-bar.props';
import { RootState } from '@store/root-reducer';
import { useRouter } from 'next-nprogress-bar';
import { UsersActions } from '@store/users/users-action';
import AutoComplete from '@modules/auto-complete';
import getParseRoute from '@utils/helpers/parse-route';
import routes from '@routes';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const UserSearchBar = ({ button = true, placeholder = 'در پزشک بوک بگرد', height, isFilter = true, callBackText, textFieldColor = 'secondary', value, searchHandlerCallback, inputClassName, className }: UserSearchBarProps) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { searchResult, searchValue, searchLoading } = useSelector((state: RootState) => state.users);

  useEffect(() => {
    dispatch(UsersActions.getUsersSearchList({ searchValue: searchValue }));
  }, []);

  const searchInputHandler = (e: any) => {
    if (isFilter) {
      dispatch(UsersActions.getUsersSearchList({ searchValue: e?.target?.value || '' }));
    } else {
      callBackText(e.target.value);
    }
  };

  const selectHandler = (e: string | number) => {
    dispatch(UsersActions.setSearchLoading({ searchLoading: true }));
    router.push(getParseRoute({ pathname: routes['route.users.show'], query: { slug: e }, locale: lang }));
  };

  const searchHandler = () => {
    dispatch(UsersActions.setFilterItems({
      key: 'search',
      id: searchValue,
      value: searchValue,
    }));

    if (searchHandlerCallback && typeof searchHandlerCallback === 'function') {
      searchHandlerCallback();
    }
  };

  return (
    <AutoComplete
      onSelect={selectHandler}
      id={'slug'}
      text={'full_name'}
      optionsList={searchResult?.data}
      placeholder={placeholder || 'جستجو کنید'}
      onChange={searchInputHandler}
      loading={searchLoading}
      button={button}
      onClick={searchHandler}
    />
  );
};

export default UserSearchBar;
